import React from 'react';
import {devAlert} from './devAlert';

/* A hook to auto-memoize a devAlert notice */
export const useDevAlert = (condition: boolean, message: string) => {
  React.useMemo(() => {
    devAlert(condition, message);
  }, [condition, message]);
};
